export const testimonials = [
  {
    id: 1,
    name: "Siti Nurhaliza",
    role: "Pengantin",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150",
    rating: 5,
    text: "Henna dari Putri sangat indah dan detail! Semua tamu pernikahan saya memuji hasil karyanya. Profesional dan hasilnya awet sampai 2 minggu. Highly recommended!",
  },
  {
    id: 2,
    name: "Dewi Kartika",
    role: "Engagement",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150",
    rating: 5,
    text: "Pelayanan ramah dan hasil henna nya sangat cantik! Design nya unik dan sesuai dengan keinginan saya. Terima kasih Putri Henna Artist!",
  },
  {
    id: 3,
    name: "Anisa Rahman",
    role: "Prewedding",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150",
    rating: 5,
    text: "White henna untuk prewedding saya benar-benar memukau! Hasil foto jadi lebih cantik dan elegan. Putri sangat teliti dan sabar dalam mengerjakan henna.",
  },
  {
    id: 4,
    name: "Rina Maulida",
    role: "Pagar Ayu",
    image: "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150",
    rating: 5,
    text: "Saya dan para bridesmaid sangat puas dengan layanan henna untuk pagar ayu. Designnya cantik dan harganya sangat reasonable. Sukses terus Putri Henna Artist!",
  },
];

export const services = [
  {
    id: 1,
    category: "Henna Wedding",
    subcategories: [
      {
        name: "Seri Henna Maroon",
        packages: [
          {
            name: "Rahayu Puspa",
            type: "Seri Henna Maroon",
            price: 270000,
            features: ["Aplikasi henna pada tangan"],
            additionalService: "Aksesoris & Lotion Pencerah +90K",
          },
          {
            name: "Sari Mustika",
            type: "Seri Henna Maroon",
            price: 290000,
            features: ["Aplikasi henna pada tangan & henna kuku"],
            additionalService: "Aksesoris & Lotion Pencerah +90K",
          },
          {
            name: "Rarasati",
            type: "Seri Henna Maroon",
            price: 330000,
            features: [
              "Aplikasi henna pada tangan dengan Press On Nails atau Henna Celup",
            ],
          },
          {
            name: "Pancawarna Agung",
            type: "Seri Henna Maroon",
            price: 400000,
            popular: true,
            features: [
              "Aplikasi henna pada tangan dengan Press On Nails atau Henna Celup",
              "Aksesoris (glitter, rhinestone)",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris ekstra +30K",
          },
        ],
      },
      {
        name: "Seri White Henna",
        packages: [
          {
            name: "Sari Mustika",
            type: "Seri White Henna",
            price: 300000,
            features: [
              "Aplikasi henna putih pada tangan",
              "Aksesoris (glitter, rhinestone)",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris ekstra (glitter & rhinestone) +30K",
          },
          {
            name: "Rarasati",
            type: "Seri White Henna",
            price: 320000,
            features: [
              "Aplikasi henna putih pada tangan dan henna kuku",
              "Aksesoris (glitter, rhinestone)",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris ekstra +30K",
          },
          {
            name: "Pancawarna Agung",
            type: "Seri White Henna",
            price: 360000,
            features: [
              "Aplikasi henna putih pada tangan dengan Press On Nails",
              "Aksesoris (glitter, rhinestone)",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris ekstra +30K",
          },
        ],
      },
      {
        name: "Seri Nude Henna Pengantin",
        packages: [
          {
            name: "Sari Mustika",
            type: "Seri Nude Henna Pengantin",
            price: 330000,
            features: [
              "Aplikasi henna nude pada tangan",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
          {
            name: "Rarasati",
            type: "Seri Nude Henna Pengantin",
            price: 350000,
            features: [
              "Aplikasi henna nude pada tangan dan henna kuku",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
          {
            name: "Pancawarna Agung",
            type: "Seri Nude Henna Pengantin",
            price: 390000,
            features: [
              "Aplikasi henna nude pada tangan dengan Press On Nails",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    category: "Henna Pagar Ayu & Bridesmaid",
    packages: [
      {
        name: "Rahayu",
        type: "Per Orang",
        price: 60000,
        features: ["Aplikasi henna maroon pada tangan"],
      },
      {
        name: "Mustika",
        type: "Per Orang",
        price: 80000,
        features: ["Aplikasi henna maroon pada tangan & henna kuku"],
      },
      {
        name: "Raras",
        type: "Per Orang",
        price: 120000,
        features: [
          "Aplikasi henna maroon pada tangan dengan Press On Nails atau henna celup",
        ],
      },
    ],
  },
  {
    id: 3,
    category: "Henna Prewedding",
    subcategories: [
      {
        name: "Seri Henna Maroon",
        packages: [
          {
            name: "Rahayu Puspa",
            type: "Seri Henna Maroon",
            price: 200000,
            features: ["Aplikasi henna pada tangan"],
            additionalService:
              "Aksesoris, Lotion Pencerah +30K | Aksesoris Ekstra, Lotion Pencerah +50K",
          },
          {
            name: "Sari Mustika",
            type: "Seri Henna Maroon",
            price: 220000,
            features: ["Aplikasi henna pada tangan & henna kuku"],
            additionalService:
              "Aksesoris, Lotion Pencerah +30K | Aksesoris Ekstra, Lotion Pencerah +50K",
          },
          {
            name: "Rarasati",
            type: "Seri Henna Maroon",
            price: 260000,
            features: [
              "Aplikasi henna pada tangan dengan Press On Nails atau Henna Celup",
            ],
            additionalService: "Aksesoris, Lotion Pencerah +30K",
          },
          {
            name: "Pancawarna Agung",
            type: "Seri Henna Maroon",
            price: 300000,
            popular: true,
            features: [
              "Aplikasi henna pada tangan dengan Press On Nails atau Henna Celup",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
        ],
      },
      {
        name: "Seri White Henna Prewedding",
        packages: [
          {
            name: "Sari Mustika",
            type: "Seri White Henna Prewedding",
            price: 230000,
            features: [
              "Aplikasi henna putih pada tangan",
              "Aksesoris (glitter, rhinestone)",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris Ekstra +25K",
          },
          {
            name: "Rarasati",
            type: "Seri White Henna Prewedding",
            price: 250000,
            features: [
              "Aplikasi henna putih pada tangan dan henna kuku",
              "Aksesoris",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris Ekstra +25K",
          },
          {
            name: "Pancawarna Agung",
            type: "Seri White Henna Prewedding",
            price: 290000,
            features: [
              "Aplikasi henna putih pada tangan dengan Press On Nails",
              "Aksesoris (glitter, rhinestone)",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris Ekstra +25K",
          },
        ],
      },
      {
        name: "Seri Nude Henna Prewedding",
        packages: [
          {
            name: "Sari Mustika",
            type: "Seri Nude Henna Prewedding",
            price: 250000,
            features: [
              "Aplikasi henna nude pada tangan",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
          {
            name: "Rarasati",
            type: "Seri Nude Henna Prewedding",
            price: 270000,
            features: [
              "Aplikasi henna nude pada tangan dan henna kuku",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
          {
            name: "Pancawarna Agung",
            type: "Seri Nude Henna Prewedding",
            price: 310000,
            features: [
              "Aplikasi henna nude pada tangan dengan Press On Nails",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
        ],
      },
    ],
  },
  {
    id: 4,
    category: "Henna Engagement",
    subcategories: [
      {
        name: "Seri Henna Maroon",
        packages: [
          {
            name: "Rahayu Puspa",
            type: "Seri Henna Maroon",
            price: 140000,
            features: ["Aplikasi henna pada tangan"],
            additionalService:
              "Aksesoris, Lotion Pencerah +15K | Aksesoris Ekstra, Lotion Pencerah +20K",
          },
          {
            name: "Sari Mustika",
            type: "Seri Henna Maroon",
            price: 160000,
            features: ["Aplikasi henna pada tangan & henna kuku"],
            additionalService:
              "Aksesoris, Lotion Pencerah +15K | Aksesoris Ekstra, Lotion Pencerah +20K",
          },
          {
            name: "Rarasati",
            type: "Seri Henna Maroon",
            price: 200000,
            features: [
              "Aplikasi henna pada tangan dengan Press On Nails atau Henna Celup",
            ],
            additionalService: "Aksesoris, Lotion Pencerah +15K",
          },
          {
            name: "Pancawarna Agung",
            type: "Seri Henna Maroon",
            price: 210000,
            popular: true,
            features: [
              "Aplikasi henna pada tangan dengan Press On Nails atau Henna Celup",
              "Aksesoris ekstra (glitter, rhinestone)",
              "Lotion Pencerah",
            ],
          },
        ],
      },
      {
        name: "Seri White Henna Lamaran",
        packages: [
          {
            name: "Sari Mustika",
            type: "Seri White Henna Lamaran",
            price: 150000,
            features: [
              "Aplikasi henna putih pada tangan",
              "Aksesoris",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris Ekstra +20K",
          },
          {
            name: "Rarasati",
            type: "Seri White Henna Lamaran",
            price: 170000,
            features: [
              "Aplikasi henna putih pada tangan dan henna kuku",
              "Aksesoris",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris Ekstra +20K",
          },
          {
            name: "Pancawarna Agung",
            type: "Seri White Henna Lamaran",
            price: 210000,
            features: [
              "Aplikasi henna putih pada tangan dengan Press On Nails",
              "Aksesoris",
              "Lotion Pencerah",
            ],
            additionalService: "Aksesoris Ekstra +20K",
          },
        ],
      },
      {
        name: "Seri Nude Henna Engagement",
        packages: [
          {
            name: "Sari Mustika",
            type: "Seri Nude Henna Engagement",
            price: 170000,
            features: [
              "Aplikasi henna nude pada tangan",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
          {
            name: "Rarasati",
            type: "Seri Nude Henna Engagement",
            price: 190000,
            features: [
              "Aplikasi henna nude pada tangan dan henna kuku",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
          {
            name: "Pancawarna Agung",
            type: "Seri Nude Henna Engagement",
            price: 230000,
            features: [
              "Aplikasi henna nude pada tangan dengan Press On Nails",
              "Aksesoris ekstra",
              "Lotion Pencerah",
            ],
          },
        ],
      },
    ],
  },
  {
    id: 5,
    category: "Henna Graduation",
    packages: [
      {
        name: "Rahayu",
        type: "Graduation Package",
        price: 55000,
        features: ["Aplikasi henna maroon pada tangan"],
      },
      {
        name: "Mustika",
        type: "Graduation Package",
        price: 70000,
        features: ["Aplikasi henna maroon pada tangan & henna kuku"],
      },
      {
        name: "Raras",
        type: "Graduation Package",
        price: 115000,
        features: [
          "Aplikasi henna maroon pada tangan dengan Press On Nails atau Henna Celup",
        ],
      },
    ],
  },
  {
    id: 6,
    category: "Fun Henna / Bridal Family",
    packages: [
      {
        name: "Fun Henna Dewasa",
        type: "Per Orang",
        price: 30000,
        features: ["Design pilihan", "Cocok untuk acara keluarga"],
      },
      {
        name: "Fun Henna Anak",
        type: "Per Orang",
        price: 20000,
        features: ["Design fun dan playful", "Aman untuk anak-anak"],
      },
    ],
  },
];

export const gallery = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1533939361134-4135bbb3658c?w=800",
    title: "Bridal Henna Elegance",
    category: "wedding",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1623217509141-6f735087b50c?w=800",
    title: "Intricate Palm Design",
    category: "wedding",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1629332791370-77208e6cbb67?w=800",
    title: "Traditional Wedding Henna",
    category: "wedding",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1588175768004-4e8a770cc099?w=800",
    title: "Gold Accented Bridal Henna",
    category: "engagement",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1764640994773-d24ca3d7930c?w=800",
    title: "Prewedding Henna Art",
    category: "prewedding",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1720238281662-9ccf8994922b?w=800",
    title: "Detailed Bridal Mehndi",
    category: "wedding",
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1570113641183-a2f16d1f098b?w=800",
    title: "Traditional Indian Bridal",
    category: "wedding",
  },
  {
    id: 8,
    image:
      "https://images.pexels.com/photos/35109957/pexels-photo-35109957.jpeg?w=800",
    title: "Couple with Henna",
    category: "engagement",
  },
];

export const faqs = [
  {
    id: 1,
    question: "Kapan White/Nude Henna digunakan?",
    answer: "White dan Nude Henna digunakan pada hari H acara.",
  },
  {
    id: 2,
    question: "Berapa lama White/Nude Henna bertahan di kulit?",
    answer:
      "White dan Nude Henna bertahan sekitar 1–2 hari, tergantung kondisi kulit.",
  },
  {
    id: 3,
    question: "Apakah White/Nude Henna meninggalkan bekas di kulit?",
    answer: "Tidak, White dan Nude Henna tidak meninggalkan bekas di kulit.",
  },
  {
    id: 4,
    question: "Apakah White/Nude Henna sah untuk sholat?",
    answer: "White dan Nude Henna tidak sah untuk sholat 5 waktu.",
  },
  {
    id: 5,
    question: "Bagaimana cara menghilangkan White/Nude Henna?",
    answer:
      "White dan Nude Henna dapat dihilangkan dengan cara merendam area henna menggunakan air hangat, lalu digosok secara perlahan.",
  },
  {
    id: 6,
    question: "Kapan Henna Maroon sebaiknya diaplikasikan?",
    answer: "Maroon Henna digunakan minimal H-1 sebelum acara.",
  },
  {
    id: 7,
    question: "Berapa lama Henna Maroon bertahan di kulit?",
    answer: "Henna Maroon bertahan sekitar 4–7 hari, tergantung kondisi kulit.",
  },
];

export const termsAndConditions = [
  {
    id: 1,
    title: "Booking Tanggal",
    description: "Booking tanggal wajib melakukan DP:",
    details: [
      "Henna Wedding/Prewedding/Engagement: sebesar 100K",
      "Henna Graduation/Fun Henna/Bridal Family/Pagar Ayu/Bridesmaid: sebesar 40%",
    ],
  },
  {
    id: 2,
    title: "Pelunasan",
    description:
      "Henna Wedding / Pagar Ayu / Bridesmaid / Bridal Family, maksimal dilakukan pada H-7. Prewedding / Engagement / Graduation / Henna Fun, maksimal dilakukan pada H-1.",
    details: [
      "Henna Wedding / Pagar Ayu / Bridesmaid / Bridal Family: maksimal H-7",
      "Prewedding / Engagement / Graduation / Henna Fun: maksimal H-1",
    ],
  },
  {
    id: 3,
    title: "Pembatalan",
    description:
      "Jika terjadi pembatalan oleh client maka berlaku aturan berikut:",
    details: [
      "Batal 3-4 hari sebelum acara: DP dapat dikembalikan",
      "Batal kurang dari 3 hari sebelum acara: DP hangus",
    ],
  },
];

export const serviceTypes = [
  "Maroon Henna",
  "White Henna",
  "Nude Henna",
  "Henna Fun bridesmaid",
  "Henna Fun Pagar Ayu",
  "Henna Fun Keluarga Pengantin",
];
